import * as React from 'react'
import Link from './Link'
import SvgLoadingSpin from './SvgLoadingSping'

const getClasses = (props: ButtonCompProps) => {
  const { variant, disabled, className = '' } = props

  const classes = [
    (() => {
      if (variant === 'default') return 'bg-accent'
      if (variant === 'light-gray') return 'bg-gray-100'
      return 'bg-white'
    })(),
    variant === 'default' ? 'text-white' : 'text-gray-900',
    disabled ? 'not-allowed cursor-not-allowed opacity-50' : '',
    'border',
    'border-transparent',
    'rounded-md',
    'shadow-sm',
    'py-2',
    'px-4',
    'inline-flex',
    'justify-center',
    'text-sm',
    'font-medium',
    !disabled && 'hover:bg-gray-700',
    !disabled && 'hover:text-white',
    'focus:outline-none',
    'focus:ring-2',
    'focus:ring-offset-2',
    'focus:ring-ledgerGreen-500',
    ...className.split(' '),
  ].join(' ')
  return classes
}

interface ButtonCompProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  center?: boolean
  disabled?: boolean
  loading?: boolean
  className?: string
  tooltip?: string
  href?: string
  variant?: 'default' | 'light-gray' | 'outlined'
  type?: 'button' | 'submit'
  title?: string
}

const ButtonComp = React.forwardRef<HTMLButtonElement, ButtonCompProps>(
  (props, ref) => {
    const {
      children,
      disabled: disabledProp,
      onClick,
      tooltip,
      loading,
      // className = '',
      title,
      type = 'submit',
      ...rest
    } = props
    const disabled = loading || disabledProp
    const classes = getClasses({ ...props, disabled })

    return (
      <>
        <button
          ref={ref}
          {...rest}
          data-tip={tooltip}
          disabled={disabled}
          onClick={onClick}
          type={type}
          className={classes}
          title={title}
        >
          {children}
          {loading && (
            <div className="ml-2">
              <SvgLoadingSpin />
            </div>
          )}
        </button>

        {/* {tooltip && (
          <ReactTooltip
            type="info"
            effect="solid"
            place="left"
            backgroundColor={'#25bdbe'}
          />
        )} */}
      </>
    )
  },
)

const Button = React.forwardRef<HTMLButtonElement, ButtonCompProps>(
  ({ href, variant = 'default', ...props }, ref) => {
    const classes = props.className ? props.className : ''

    if (href)
      return (
        <Link className={classes} href={href}>
          <ButtonComp
            ref={ref}
            {...props}
            className={classes}
            variant={variant}
          />
        </Link>
      )

    return <ButtonComp ref={ref} {...props} variant={variant} />
  },
)

export default Button
